import { useQuery } from '@tanstack/react-query';
import { ordersService } from '@/services/ordersService';
import { queryKeys } from '@/lib/queryKeys';

export const useOrderLineItems = (orderId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.orders.lineItems(orderId ?? ''),
    queryFn: () => {
      if (!orderId) {
        throw new Error('Order ID is required');
      }
      return ordersService.getOrderLineItems(orderId);
    },
    enabled: Boolean(orderId),
    staleTime: 30_000,
  });
};
